<div class="filter-popover-container">
    <hc-search-bar #popoverSearchBar placeholder="Search" (triggerSearch)="textFilter($event)"></hc-search-bar>
    <div class="filter-popover-count">Showing {{ filterCount }} of {{ this.filterData && this.filterData.length }}</div>
    <div class="filter-popover-buttons">
        <button hc-button buttonStyle="link" size="sm" [disabled]="disableSelectAll" (click)="selectAll()">Select All</button>
        <button hc-button buttonStyle="link" size="sm" [disabled]="disableSelectNone" (click)="selectNone()">Clear All</button>
    </div>
    <div class="filter-popover-options-container">
        <hc-checkbox *ngFor="let filterVal of filterData" (change)="checkEvent(filterVal)" [checked]="setVals.includes(filterVal)">
            <span class="filter-check">{{ filterVal.toString() }}</span>
        </hc-checkbox>
        <div></div>
    </div>
    <button hc-button size="sm" class="filter-popover-done-btn" (click)="close.emit()">Done</button>
</div>
